export const messages = {
  en: {
    message: {
      'Geo_контроль':'Geo',
      'Geo_enabled':'Enabled',
      'Geo_тип_списка':'Type list:',
      'Geo_коды':'Codes',
      'Geo_не_удалось_получить_список_кодов_стран':'Error occured when receiving the data: Geo Codes',
      'EPG_Каналы': 'EPG Channels',
      'Login': 'Login',
      'IPs_контроль':'IPs control',
      'Абоненты': 'Accounts',
      'Адаптер': 'Adapter',
      'Администрирование': 'Administration',
      'Адрес': 'Address',
      'Активен': 'Active',
      'Включен': 'Enabled',
      'Возраст': 'Age',
      'Выводить_на_сайте': 'Display on site',
      'Выгружать_в_маркет': 'Market accessable',
      'Выход': 'Exit',
      'Главная': 'Main',
      'Да': 'Yes',
      'Действительно_удалить_запись?': 'Are you sure you want to delete the item?',
      'Действительно_удалить_источник?': 'Are you sure you want to delete the source?',
      'Действительно_удалить_канал?': 'Are you sure you want to delete  the channel?',
      'Действительно_удалить_категорию?': 'Are you sure you want to delete the category?',
      'Действительно_удалить_пакет?': 'Are you sure you want to delete the subscription',
      'Действительно_удалить_пользователя?': 'Are you sure you want to delete the user?',
      'Действительно_удалить_поток?': 'Are you sure you want to delete the stream?',
      'Действительно_удалить_роль?': 'Are you sure you want to delete the role?',
      'Действительно_удалить_сервис?': 'Are you sure you want to delete the service?',
      'Добавить': 'Add new',
      'Добавить_EPG': 'Add EPG',
      'Добавить_канал': 'Add Channel',
      'Добавить_категорию': 'Add category',
      'Добавить_пакет': 'Add package',
      'Добавить_пользователя': 'Add user',
      'Добавить_поток': 'Add stream',
      'Добавить_роль': 'Add role',
      'Добавить_сервис': 'Add service',
      'Добро_пожаловать_в_панель_управления': 'Welcome to the management panel',
      'Закрыть': 'Close',
      'Записи_не_найдены': 'No records found',
      'Запись_успешно_сохранена': 'Saved successfully',
      'Запись_успешно_удалена': 'Deleted successfully',
      'Импортировать_лого': 'Import logo from source',
      'Источник_для_отображения_каналов': 'Channel source',
      'Источники_импорта_-_Редактирование': 'Import sources - Edit',
      'Источники_импорта': 'EPG sources',
      'Импорт_програмы': 'Import',
      'Импорт_програмы_успешно':'Import has done',
      'К_списку_абонентов': 'List of accounts',
      'К_списку_пакетов': 'List of packages',
      'К_списку_каналов': 'List of channels',
      'К_списку_сервисов': 'List of services',
      'К_списку_категорий': 'List of categories',
      'К_списку_колокейшинов': 'List of colocations',
      'К_списку_фильмов': 'List of movies',
      'Каналы_-_Редактирование': 'Channels - Edit',
      'Каналы_источников': 'Channels for sources',
      'Каналы': 'Channels',
      'Категории_-_Редактирование': 'Categories - Edit',
      'Категории': 'Categories',
      'Категории_-_Extended': 'Extended',
      'Колокейшн': 'Colocation',
      'Колокейшены': 'Colocations',
      'Колокейшены_-_Редактирование': 'Colocations - Edit',
      'Колокейшн_запасной': 'Colocation spare',
      'Колокейшин_запасной_включен': 'Colocation spare enabled',
      'Комментарий': 'Comment',
      'Контакты':'Contacts',
      'Коррекция_времени_EPG': 'EPG offset (sec.)',
      'Лайв-стриминг': 'Live streaming',
      'Логотип': 'Logo image',
      'Макс_адресов': 'Max. addresses',
      'Макс_потоков': 'Max. streams',
      'Минимальный_возраст': 'Min.age',
      'Название': 'Name',
      'Неверное_значение': 'Wrong value',
      'Нет': 'No',
      'Новый_пароль': 'New password',
      'Обработчик': 'Handler',
      'Общие': 'Common',
      'Описание': 'Description',
      'Опции': 'Options',
      'Отмена': 'Cancel',
      'Ошибка_получения_данных': 'Error occured when receiving the data',
      'Ошибка_сохранения': 'Could not save',
      'Ошибка_удаления_записи': 'Could not delete',
      'Пакеты_-_Редактирование': 'Package - Edit',
      'Пакеты': 'Packages',
      'Пароли_не_совпадают': 'Password does not match',
      'Пароль_не_может_быть_пустым': 'Could not use empty passwords',
      'Пароль_успешно_изменен': 'Password successfully changed',
      'Пароль': 'Password',
      'Партнёр': 'Partner',
      'потоки_клонирование_завершилось':'Streams cloning completed',
      'потоки_ошибка_клонирования':'Stream cloning is not completed',
      'потоки_клонирование':'Клонирование',
      'потоки_действительно_клонировать?': 'Действительно клонировать?',
      'Потоки': 'Потоки',
      'Посмотреть_потоки': 'Streams',
      'Поток_-_Редактирование': 'Stream - Edit',
      'Тип_аккаунта' : 'Type',
      'Тип_аккаунта_дата_обновления' : 'Type updated at',
      'Повторите_пароль': 'Reenter password',
      'Пользователи_-_Редактирование': 'Users - Edit',
      'Пользователи': 'Users',
      'Порядок_сохранён': 'Order saved',
      'Применять_точные_метки': 'Apply EPG correction labels',
      'Программа_передач_-_Просмотр': 'EPG - View',
      'Продолжительность_хранения_записи_(дней)': 'Record lifetime (days)',
      'Редактирование_абонента': 'Account edit',
      'Родительский_код': 'Parent code',
      'Роли_-_Редактирование': 'Roles - Edit',
      'Роли': 'Roles',
      'Сервисы_-_Редактирование': 'Services - Edit',
      'Сервисы_ключей_-_Редактирование': 'Key services - Edit',
      'Сервисы_ключей': 'Key services',
      'Сервисы': 'Services',
      'Сменить_пароль': 'Change password',
      'Смещение_прямого_эфира': 'Live broadcast offset',
      'Гео_контроль': 'Geo control',
      'Смотреть_программу': 'Show',
      'Создать': 'New',
      'Сохранить': 'Save',
      'Список_каналов_-_Просмотр': 'Channels - View',
      'Управление_Источниками_импорта': 'EPG sources management',
      'Статистика': 'Statistics',
      'Статистика_Dashboard': 'Dashboard',
      'Статистика_Дневной_отчет': 'Reports',
      'Статистика_Megogo': 'Megogo',
      'Статистика_Создание_Отчета': 'Create report',
      'Статистика_Отчет_Готов': 'Report ready',
      'Статистика_Лог_запросов': 'Log requests',
      'Статистика_Лог_сессий': 'Log sessions',
      'Timeshift_Enabled':'Timeshift',
      'Apks': 'Apks',
      'Apk_Добавить'      : 'Add Apk',
      'Apk_Редактирование': "Apk Edit",
      'Apk_enabled'       : 'Enabled',
      'Apk_description'   : 'Description',
      'Apk_version'       : 'Version',
      'Apk_build'         : 'Build',
      'Apk_payload'       : 'Apk file',
      'Apk_name'          : 'File name',
      'Apk_ips_list'      : 'IPs list only',
      'Apk_ips_only'      : 'IPs only',
      'Apk_ips_exclude'   : 'IPs exclude',
      'Apk_ips_re_only'   : 'IPs last digitals only',
      'Apk_ips_re_exclude': 'IPs last digitals exclude',
      'Видеотека'         : 'Movies',
      'Видеотека_Каталог' : 'Movies',
      'Видеотека_-_Редактирование': 'Movie - Edit',
      'Видеотека_-_Описание': 'Description',
      'Видеотека_-_Жанры' : 'VOD Genres',
      'Видеотека_-_id' : 'ID',
      'Видеотека_-_Продолжительность' : 'Mins',
      'Видеотека_-_Контроль' : 'Control',
      'Видеотека_-_Режисеры' : 'Directors',
      'Видеотека_-_Актеры' : 'Actors',
      'Видеотека_-_Год' : 'Year',
      'Видеотека_-_Пакеты' : 'VOD Packages',
      'Видеотека_-_Пакеты_Редактирование': 'VOD Package - Edit',
      'Видеотека_-_Пакеты_Список_фильмов': 'VOD Package - Movies',
      'Видеотека_-_Сервисы': 'VOD Services',
      'Страны'            : 'Countries'
    }
  },
  ru: {
    message: {
      'Geo_контроль':'Geo Контроль',
      'Geo_enabled':'Включен',
      'Geo_тип_списка':'Тип списка:',
      'Geo_коды':'Коды',
      'Geo_не_удалось_получить_список_кодов_стран':'Не удалось получить коды стран',
      'EPG_Каналы': 'EPG Каналы',
      'Login': 'Авторизация',
      'IPs_контроль':'IPs контроль',
      'Абоненты': 'Абоненты',
      'Адаптер': 'Адаптер',
      'Администрирование': 'Администрирование',
      'Адрес': 'Адрес',
      'Активен': 'Активен',
      'Включен': 'Включен',
      'Возраст': 'Возраст',
      'Выводить_на_сайте': 'Выводить на сайте',
      'Выгружать_в_маркет': 'Выгружать в маркет',
      'Выход': 'Выход',
      'Главная': 'Главная',
      'Да': 'Да',
      'Действительно_удалить_запись?': 'Действительно удалить запись?',
      'Действительно_удалить_источник?': 'Действительно удалить источник?',
      'Действительно_удалить_канал?': 'Действительно удалить канал?',
      'Действительно_удалить_категорию?': 'Действительно удалить категорию?',
      'Действительно_удалить_пакет?': 'Действительно удалить пакет?',
      'Действительно_удалить_пользователя?': 'Действительно удалить пользователя?',
      'Действительно_удалить_поток?': 'Действительно удалить поток?',
      'Действительно_удалить_роль?': 'Действительно удалить роль?',
      'Действительно_удалить_сервис?': 'Действительно удалить сервис?',
      'Добавить': 'Добавить',
      'Добавить_EPG': 'Добавить EPG',
      'Добавить_канал': 'Добавить канал',
      'Добавить_категорию': 'Добавить категорию',
      'Добавить_пакет': 'Добавить пакет',
      'Добавить_пользователя': 'Добавить пользователя',
      'Добавить_поток': 'Добавить поток',
      'Добавить_роль': 'Добавить роль',
      'Добавить_сервис': 'Добавить сервис',
      'Добро_пожаловать_в_панель_управления': 'Добро пожаловать в панель управления',
      'Закрыть': 'Закрыть',
      'Записи_не_найдены': 'Записи не найдены',
      'Запись_успешно_сохранена': 'Запись успешно сохранена',
      'Запись_успешно_удалена': 'Запись успешно удалена',
      'Импортировать_лого': 'Импортировать лого с источника',
      'Источник_для_отображения_каналов': 'Источник для отображения каналов',
      'Источники_импорта_-_Редактирование': 'Источники импорта - Редактирование',
      'Источники_импорта': 'Источники импорта',
      'Импорт_програмы': 'Импорт',
      'Импорт_програмы_успешно':'Импорт програмы завершился',
      'К_списку_абонентов': 'К списку абонентов',
      'К_списку_пакетов': 'К списку пакетов',
      'К_списку_каналов': 'К списку каналов',
      'К_списку_сервисов': 'К списку сервисов',
      'К_списку_категорий': 'К списку категорий',
      'К_списку_колокейшинов': 'К списку колокейшинов',
      'К_списку_фильмов': 'К списку фильмов',
      'Каналы_-_Редактирование': 'Каналы - Редактирование',
      'Каналы_источников': 'Каналы источников',
      'Каналы': 'Каналы',
      'Категории_-_Редактирование': 'Категории - Редактирование',
      'Категории': 'Категории',
      'Категории_-_Extended': 'Extended',
      'Колокейшн': 'Колокейшн',
      'Колокейшены': 'Колокейшены',
      'Колокейшены_-_Редактирование': 'Колокейшены - Редактирование',
      'Колокейшн_запасной': 'Colocation spare',
      'Колокейшин_запасной_включен': 'Colocation spare enabled',
      'Комментарий': 'Комментарий',
      'Контакты':'Контакты',
      'Коррекция_времени_EPG': 'Коррекция времени EPG (сек.)',
      'Лайв-стриминг': 'Лайв-стриминг',
      'Логотип': 'Логотип',
      'Макс_адресов': 'Макс. адресов',
      'Макс_потоков': 'Макс. потоков',
      'Минимальный_возраст': 'Мин.возраст',
      'Название': 'Название',
      'Неверное_значение': 'Неверное значение',
      'Нет': 'Нет',
      'Новый_пароль': 'Новый пароль',
      'Обработчик': 'Обработчик',
      'Общие': 'Общие',
      'Описание': 'Описание',
      'Опции': 'Опции',
      'Отмена': 'Отмена',
      'Ошибка_получения_данных': 'Ошибка получения данных',
      'Ошибка_сохранения': 'Ошибка сохранения',
      'Ошибка_удаления_записи': 'Ошибка удаления записи',
      'Пакеты_-_Редактирование': 'Пакеты - Редактирование',
      'Пакеты': 'Пакеты',
      'Пароли_не_совпадают': 'Пароли не совпадают',
      'Пароль_не_может_быть_пустым': 'Пароль не может быть пустым',
      'Пароль_успешно_изменен': 'Пароль успешно изменен',
      'Пароль': 'Пароль',
      'Партнёр': 'Партнёр',
      'потоки_клонирование_завершилось':'Клонирование выполнено',
      'потоки_ошибка_клонирования':'Клонирование не выполнено',
      'потоки_клонирование':'Клонирование',
      'потоки_действительно_клонировать?': 'Действительно клонировать?',      
      'Потоки': 'Потоки',
      'Посмотреть_потоки': 'Streams',
      'Поток_-_Редактирование': 'Stream - Edit',
      'Тип_аккаунта' : 'Тип',
      'Тип_аккаунта_дата_обновления' : 'Тип обновлён',
      'Повторите_пароль': 'Повторите пароль',
      'Пользователи_-_Редактирование': 'Пользователи - Редактирование',
      'Пользователи': 'Пользователи',
      'Порядок_сохранён': 'Порядок сохранён',
      'Посмотреть_потоки': 'Посмотреть потоки',
      'Применять_точные_метки': 'Применять точные метки',
      'Программа_передач_-_Просмотр': 'Программа передач - Просмотр',
      'Продолжительность_хранения_записи_(дней)': 'Продолжительность хранения записи (дней)',
      'Редактирование_абонента': 'Редактирование абонента',
      'Родительский_код': 'Родительский код',
      'Роли_-_Редактирование': 'Роли - Редактирование',
      'Роли': 'Роли',
      'Сервисы_-_Редактирование': 'Сервисы - Редактирование',
      'Сервисы_ключей_-_Редактирование': 'Сервисы ключей - Редактирование',
      'Сервисы_ключей': 'Сервисы ключей',
      'Сервисы': 'Сервисы',
      'Сменить_пароль': 'Сменить пароль',
      'Смещение_прямого_эфира': 'Смещение прямого эфира',
      'Гео_контроль': 'Гео контроль',
      'Смотреть_программу': 'Смотреть программу',
      'Создать': 'Создать',
      'Сохранить': 'Сохранить',
      'Список_каналов_-_Просмотр': 'Список каналов - Просмотр',
      'Управление_Источниками_импорта': 'Управление Источниками импорта',
      'Статистика': 'Статистика',
      'Статистика_Dashboard': 'Дашбоард',
      'Статистика_Дневной_отчет': 'Отчеты',
      'Статистика_Megogo': 'Megogo',
      'Статистика_Создание_Отчета': 'Создание отчета',
      'Статистика_Отчет_Готов': 'Отчет готов',
      'Статистика_Лог_запросов': 'Лог запросов',
      'Статистика_Лог_сессий': 'Лог сессий',
      'Timeshift_Enabled':'Timeshift',
      'Apks': 'Apks',
      'Apk_Добавить'      : 'Добавить Apk',
      'Apk_Редактирование': "Apk Редактирование",
      'Apk_enabled'       : 'Включен',
      'Apk_description'   : 'Описание',
      'Apk_version'       : 'Версия',
      'Apk_build'         : 'Сборка',
      'Apk_payload'       : 'APK',
      'Apk_name'          : 'Имя файла',
      'Apk_ips_only'      : 'IPs: CIDR разрешения',
      'Apk_ips_exclude'   : 'IPs: CIDR исключения',
      'Apk_ips_list'      : 'IPs список разрешенных',
      'Apk_ips_re_only'   : 'IPs крайние цифры: разрешения',
      'Apk_ips_re_exclude': 'IPs крайние цифры: исключения',
      'Видеотека'                         : 'Видеотека',
      'Видеотека_Каталог'                 : 'Видеотека',
      'Видеотека_-_Редактирование'        : 'Видеотека - Редактирование',
      'Видеотека_-_Описание'              : 'Описание',
      'Видеотека_-_Жанры'                 : 'VOD Жанры',
      'Видеотека_-_id'                    : 'ID',
      'Видеотека_-_Продолжительность'     : 'Mins',
      'Видеотека_-_Контроль'              : 'Контроль',
      'Видеотека_-_Режисеры'              : 'Режисеры',
      'Видеотека_-_Актеры'                : 'Актеры',
      'Видеотека_-_Год'                   : 'Год',
      'Видеотека_-_Пакеты'                : 'VOD Пакеты',
      'Видеотека_-_Пакеты_Редактирование' : 'VOD Пакеты - Редактирование',
      'Видеотека_-_Пакеты_Список_фильмов' : 'VOD Пакеты - Список_фильмов',
      'Видеотека_-_Сервисы'               : 'VOD Сервисы',
      'Страны'                            : 'Страны'
    }
  }
}



// WEBPACK FOOTER //
// ./src/localization/message.js